export default __webpack_public_path__ + "static/media/20.a4eaa92c.jpg";